<script lang="ts" setup>
defineProps<{
  errors: string | Record<string, string>;
}>();
</script>
<template>
  <div class="white-box q-pt-md q-pb-md">
    <p v-if="typeof errors === 'string'" class="error-text">
      {{ errors }}
    </p>
    <template v-else>
      <p v-for="(message, key) in errors" :key="`drug-alert-error${key}`" class="error-text">
        {{ key }} {{ message }}
      </p>
    </template>
  </div>
</template>

<style scoped lang="scss">
.white-box {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: var(--box-shadow);
}
</style>
